import React, { FC } from 'react';
import { DividerWithLabel } from '@minecraft.atoms';
import { useTranslation } from '@blocs.i18n';
import { ApplePay } from '../../ApplePay';
import { PayPal } from '../../PayPal';

export type ExpressPaymentSectionProps = {
  showApplePayButton?: boolean;
  onClickApplePay: () => void;
  showPayPal?: boolean;
  onClickPayPal: () => void;
};

export const ExpressPaymentSection: FC<ExpressPaymentSectionProps> = ({
  showApplePayButton,
  onClickApplePay,
  showPayPal,
  onClickPayPal,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <ApplePay showApplePay={showApplePayButton} onClick={onClickApplePay} />
      <PayPal showPayPal={showPayPal} onClick={onClickPayPal} />
      {(showApplePayButton || showPayPal) && <DividerWithLabel label={t('common:billing.card.or')} />}
    </>
  );
};
